import { EVENT_NAMES, emit } from 'root/widgets/events';
import type { ContextData } from 'root/widgets/types';

export const handleCarouselSelection = (
  selectedIndex: number,
  event: any,
  index: number,
  length: number,
  setIndex: (idx: number) => void,
): void => {
  const navButton = event && event.target && event.target.firstChild && event.target.firstChild.dataset?.direction;

  const isLeftIcon = navButton === 'left';
  const isRightIcon = navButton === 'right';

  // allow if click source is indicators
  const isIndicatorSlide = event?.target?.tagName === 'BUTTON';

  // check if the images are at the start or end of the carousel loop
  const isFirstImage = index === 0 && selectedIndex === length - 1 && isLeftIcon;
  const isLastImage = index === length - 1 && selectedIndex === 0 && isRightIcon;

  if ((!isFirstImage && !isLastImage) || isIndicatorSlide) {
    setIndex(selectedIndex);
  }
};

const handleIconClick = (context?: ContextData) => {
  emit(EVENT_NAMES.REDUCED_LISTING_CARD_GROUP_CAROUSEL.CLICK_SCROLL, context);
};

export const getNavIcon = (
  direction: string,
  index: number,
  finalIndex: number,
  context?: ContextData,
): React.ReactNode => (
  <i
    data-direction={direction}
    className={`pgicon-arrow-${direction} ${index === finalIndex ? 'disabled' : ''}`}
    onClick={() => handleIconClick(context)}
  />
);
